import React from 'react';
import Slider from 'react-slick';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isEmpty } from 'lodash';
import { Container } from './styles/Container.styled';
import {
  Slide,
  FourCarousel,
  Slidercard,
  SliderImage,
  SliderCardCaption,
  SliderCardDisabled,
} from './styles/FullWidthSlider.styled';

export default function ImageCards({ data, id, dir }) {
  const settings = {
    slidesToShow: data.length < 4 ? data.length : 4,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3500,
    dots: true,
    arrows: true,
    rtl: dir === 'rtl',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: data.length < 3 ? data.length : 3,
          centerMode: true,
          centerPadding: '50px',
        },
      },
      {
        breakpoint: 991,
        settings: {
          arrows: true,
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '200px',
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: true,
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '120px',
        },
      },
      {
        breakpoint: 576,
        settings: {
          arrows: false,
          slidesToShow: 1,
          autoplay: false,
          centerMode: true,
          centerPadding: '130px',
        },
      },
      {
        breakpoint: 530,
        settings: {
          arrows: false,
          slidesToShow: 1,
          autoplay: false,
          centerMode: true,
          centerPadding: '50px',
        },
      },
    ],
  };
  return (
    <Container id={id} className="zeropadding_responsive">
      <FourCarousel className="card_list" dir={dir}>
        <Slider {...settings}>
          {isEmpty(data) ||
            data.map((value) => {
              if (isEmpty(value)) return null;
              const { title, link, image, text, subtitle } = value.content;
              return (
                <Slide dir={dir}>
                  {isEmpty(image) ? (
                    <SliderCardDisabled>
                      <SliderImage>
                        <LazyLoadImage
                          src={image ? image.url : ''}
                          alt={title}
                          effect="blur"
                          placeholderSrc={image ? `${image.url}?width=50&quality=50` : null}
                        />
                      </SliderImage>
                      <SliderCardCaption dir={dir} className="card_slidercap">
                        <h3 dir={dir}>{title}</h3>
                        <p className="carousel_p" dir={dir}>
                          {text || subtitle}
                        </p>
                      </SliderCardCaption>
                    </SliderCardDisabled>
                  ) : (
                    <Slidercard to={isEmpty(link) || link.url.replace('/dwtc/', '/en/')}>
                      <SliderImage>
                        <LazyLoadImage
                          src={image ? image.url : ''}
                          alt={title}
                          effect="blur"
                          placeholderSrc={image ? `${image.url}?width=50&quality=50` : null}
                        />
                      </SliderImage>
                      <SliderCardCaption dir={dir} className="card_slidercap">
                        <h3 dir={dir}>{title}</h3>
                        <p className="carousel_p" dir={dir}>
                          {text || subtitle}
                        </p>
                      </SliderCardCaption>
                    </Slidercard>
                  )}
                </Slide>
              );
            })}
        </Slider>
      </FourCarousel>
    </Container>
  );
}
